module.exports = __webpack_public_path__ + "img/PODER.ddac43c6.png";